import React from 'react';
// @ts-ignore
import { Heading } from 'arag-ui-lib';
import style from './pageNotFount.module.scss';
import { useTranslation } from 'react-i18next';

const PageNotFound = (): JSX.Element => {
    const { t } = useTranslation();
    return (
        <div className={`${style['page-not-found']}`}>
            <Heading variant="h2" title={t<string>('pageNotFound')} />
            <div>{t<string>('pageNotExist')}</div>
        </div>
    );
};

export default PageNotFound;
